import React, { Component } from 'react'
import { injectSagas, removeSaga } from 'redux-saga-injector'
import curry from 'lodash/curry'

const injectSagaHoc = (sagas) =>  (WrappedComponent) => {
  return class InjectSaga extends Component {
    static WrappedComponent = WrappedComponent

    componentWillMount() {
      const sagaObj = Object.keys(sagas).reduce((result, sagaName) => {
        return {
          ...result,
          [sagaName]: {
            saga: sagas[sagaName],
            options: {
              sagaProps: this.props,
            },
          },
        }
      }, {})

      injectSagas(sagaObj)
    }

    componentWillUnmount() {
      Object.keys(sagas).forEach(sagaName => {
        removeSaga(sagaName)
      })
    }

    render() {
      return <WrappedComponent {...this.props}/>
    }
  }
}

export default injectSagaHoc
